export function trackEvent(eventName, params = {}) {
  try {
    if (typeof window === 'undefined') return;
    if (window.gtag) {
      window.gtag('event', eventName, params);
      return;
    }
    if (window.dataLayer && typeof window.dataLayer.push === 'function') {
      window.dataLayer.push({ event: eventName, ...params });
    }
  } catch (_) {
    // no-op
  }
}

export function trackClick(eventLabel, category = 'engagement', eventName = 'link_click', extra = {}) {
  trackEvent(eventName, { event_category: category, event_label: eventLabel, ...extra });
}

